import { render, staticRenderFns } from "./OnlineSeminar.vue?vue&type=template&id=6f1612f2&"
import script from "./OnlineSeminar.vue?vue&type=script&lang=js&"
export * from "./OnlineSeminar.vue?vue&type=script&lang=js&"
import style0 from "./OnlineSeminar.vue?vue&type=style&index=0&id=6f1612f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports